import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

interface InvoiceItem {
  product_id?: string;
  name: string;
  qty: number;
  price: number;
}

@Component({
  selector: 'app-view-invoice-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './view-invoice-modal.component.html',
  styleUrls: ['./view-invoice-modal.component.scss']
})
export class ViewInvoiceModalComponent {
  @Input() invoice: any;
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }

  getItemTotal(item: InvoiceItem): number {
    return item.qty * item.price;
  }

  getItemsTotal(): number {
    if (!this.invoice.items || this.invoice.items.length === 0) {
      return 0;
    }
    return this.invoice.items.reduce((sum: number, item: InvoiceItem) => sum + this.getItemTotal(item), 0);
  }

  getBalanceDue(): number {
    return Number(this.invoice.amount) - Number(this.invoice.amount_paid);
  }

  getStatusClass(status: string): string {
    switch (status?.toLowerCase()) {
      case 'paid': return 'status-paid';
      case 'pending': return 'status-pending';
      case 'failed': return 'status-failed';
      case 'in_progress': return 'status-in-progress';
      default: return '';
    }
  }
}
